import { render, staticRenderFns } from "./ContactConsultingSettingsUpdate.vue?vue&type=template&id=5c1d6628"
import script from "./ContactConsultingSettingsUpdate.vue?vue&type=script&lang=js"
export * from "./ContactConsultingSettingsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports